import type { InstitutionTheme } from '../types';
import { umdColors } from './colors';

export const umdTheme: InstitutionTheme = {
  slug: 'umd',
  universityName: 'University of Maryland',
  universityShortName: 'UMD',
  registrationPortalName: 'Testudo',
  // Representative UMD course codes — span CS, math, English so the
  // examples don't read as CS-only. The first is used as the primary
  // placeholder text.
  exampleCourseCodes: ['CMSC131', 'CMSC498', 'MATH140'],
  colors: umdColors,
};
